export default __webpack_public_path__ + "static/media/jabir.34671a74.png";